export var AccessTypeEnum;
(function (AccessTypeEnum) {
    AccessTypeEnum[AccessTypeEnum["FREE"] = 1] = "FREE";
    AccessTypeEnum[AccessTypeEnum["OWNED"] = 2] = "OWNED";
    AccessTypeEnum[AccessTypeEnum["SHARED"] = 3] = "SHARED";
    AccessTypeEnum[AccessTypeEnum["NO_ACCESS"] = 4] = "NO_ACCESS";
})(AccessTypeEnum || (AccessTypeEnum = {}));
